import { getDefaultClient } from '../../factory';
// @endpoint GET /apps/:app_id/kiosk
// @controller UserAction.KioskScreens
export async function getKioskScreens(appId) {
    return getDefaultClient().get(`/apps/${appId}/kiosk`);
}
